export default __webpack_public_path__ + "static/media/single-left-border-right.4d487046.svg";